import { Switch } from '@headlessui/react'
import { ReactElement } from 'react'
import { classNames } from 'utils'
import clsx from 'clsx'

interface GNewTogglePropsType {
	label?: string
	activeColor?: string | 'success' | 'warning' | 'danger'
	description?: string | ReactElement
	checked: boolean
	disabled?: boolean
	onChange: (checked: boolean) => void
	labelClassName?: string
	className?: string
}

export const GNewToggle = (props: GNewTogglePropsType) => {
	const { label, description, disabled, checked, onChange, labelClassName, className = 'flex items-center justify-start space-x-4' } =
		props
	const switchClassName = clsx(
		'rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none items-center',
		checked
			? 'bg-t-dark-blue'
			: 'bg-t-unactive'
	)
	const ringClassName = `bg-${
		checked ? 't-smoke' : 't-smoke'
	} shadow transform ring-0 transition ease-in-out duration-200`

	return (
		<Switch.Group
			as="div"
			className={className}
		>
			<Switch
				disabled={disabled ? disabled : false}
				checked={checked}
				onChange={onChange}
				className={`flex flex-shrink-0 h-6 w-10  ${switchClassName}`}
			>
				<span
					aria-hidden="true"
					className={classNames(
						checked ? 'translate-x-[1.2rem]' : 'translate-x-1',
						`pointer-events-none inline-block h-4 w-4 rounded-full ${ringClassName} `
					)}
				/>
			</Switch>
			{label || description ? (
				<span className="flex flex-col">
					{label && (
						<Switch.Label
							as="span"
							className={`${
								labelClassName || 'text-md font-medium text-t-dark'
							}`}
							passive
						>
							{label}
						</Switch.Label>
					)}
					{description && (
						<Switch.Description as="span" className="text-sm text-t-secondary">
							{description}
						</Switch.Description>
					)}
				</span>
			) : null}
		</Switch.Group>
	)
}
